import DemoAuth from './DemoAuth';

export default DemoAuth;
